import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "./theme";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ProSidebarProvider } from "react-pro-sidebar";
import LogIn from "./pages/LogIn";
import UserDashboard from "./pages/user/UserDashboard";
import UserRoute from "./component/UserRoute";
import AdminRoute from "./component/AdminRoute";
import Layout from "./pages/global/Layout";
import UserJobsHistory from "./pages/user/UserJobsHistory";
import UserInfoDashboard from "./pages/user/UserInfoDashboard";
import AdminDashboard from "./pages/admin/AdminDashboard";
import DashUsers from "./pages/admin/DashUsers";
import DashJobs from "./pages/admin/DashJobs";
import Register from "./pages/Register/Register";
import CreateJob from "./pages/CreateJobs";
import DashCompany from "./pages/admin/DashCompany";
import EditProfile from "./pages/EditProfile";
import Contact from "./pages/Contact";
import React from "react";
import JobSingle from "./pages/JobSingle";
import About from "./pages/About";
import BlogSingle from "./pages/BlogSingle";
import Gallery from "./pages/Gallery";
import JobListing from "./pages/JobListing";
import Services from "./pages/Services";
import Form from "./component/Form.jsx";
import CreateCompany from "./pages/createCompany.jsx";
import AppliedUsers from "./pages/appliedUsers";
import UserApplied from "./pages/UsersApplied";
import AppliedJobs from "./pages/appliedJobs/appliedJobs";

//HOC
const UserDashboardHOC = Layout(UserDashboard);
const UserJobsHistoryHOC = Layout(UserJobsHistory);
const UserInfoDashboardHOC = Layout(UserInfoDashboard);
const AdminDashboardHOC = Layout(AdminDashboard);
const DashUsersHOC = Layout(DashUsers);
const DashJobsHOC = Layout(DashJobs);
const DashCompanyHOC = Layout(DashCompany);

const App = () => {
  return (
    <>
      <ToastContainer />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ProSidebarProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/search/location/:location" element={<Home />} />
              <Route path="/search/:keyword" element={<Home />} />
              <Route path="/login" element={<Form />} />
              <Route path="/register" element={<Form />} />
              <Route path="/registerAsBusiness" element={<Form />} />
              <Route path="/createJob" element={<CreateJob />} />
              <Route path="/admin/dashboard" element={<AdminDashboardHOC />} />
              <Route path="/admin/users" element={<DashUsersHOC />} />
              <Route path="/admin/jobs" element={<DashJobsHOC />} />
              <Route path="/admin/company" element={<DashCompanyHOC />} />
              <Route path="/company/appliedUsers" element={<AppliedUsers />} />
              <Route
                path="/company/appliedUsers/:id"
                element={<UserApplied />}
              />
              <Route
                path="/user/dashboard"
                element={
                  <UserRoute>
                    <UserDashboardHOC />
                  </UserRoute>
                }
              />
              <Route
                path="/user/jobs"
                element={
                  <UserRoute>
                    <UserJobsHistoryHOC />
                  </UserRoute>
                }
              />
              <Route
                path="/user/info"
                element={
                  <UserRoute>
                    <UserInfoDashboardHOC />
                  </UserRoute>
                }
              />
              <Route path="/createJob" element={<CreateJob />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/jobSingle/:id" element={<JobSingle />} />
              <Route path="/about" element={<About />} />
              <Route path="/blogSingle" element={<BlogSingle />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/jobListing" element={<JobListing />} />
              <Route path="/services" element={<Services />} />
              <Route path="/createCompany" element={<CreateCompany />} />
              <Route path="/user/profile/:id" element={<EditProfile />} />
              <Route path="/appliedJobs" element={<AppliedJobs />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </ProSidebarProvider>
      </ThemeProvider>
    </>
  );
};

export default App;
